export default __webpack_public_path__ + "static/media/table5seatDiagonal.0798585c.svg";